/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropXTweetResponse } from './DropXTweetResponse';
import {
    DropXTweetResponseFromJSON,
    DropXTweetResponseFromJSONTyped,
    DropXTweetResponseToJSON,
    DropXTweetResponseToJSONTyped,
} from './DropXTweetResponse';

/**
 * 
 * @export
 * @interface DropXTweetsResponse
 */
export interface DropXTweetsResponse {
    /**
     * 
     * @type {string}
     * @memberof DropXTweetsResponse
     */
    handle: string | null;
    /**
     * 
     * @type {Array<DropXTweetResponse>}
     * @memberof DropXTweetsResponse
     */
    tweets: Array<DropXTweetResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropXTweetsResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropXTweetsResponse interface.
 */
export function instanceOfDropXTweetsResponse(value: object): value is DropXTweetsResponse {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('tweets' in value) || value['tweets'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropXTweetsResponseFromJSON(json: any): DropXTweetsResponse {
    return DropXTweetsResponseFromJSONTyped(json, false);
}

export function DropXTweetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropXTweetsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'tweets': ((json['tweets'] as Array<any>).map(DropXTweetResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropXTweetsResponseToJSON(json: any): DropXTweetsResponse {
    return DropXTweetsResponseToJSONTyped(json, false);
}

export function DropXTweetsResponseToJSONTyped(value?: DropXTweetsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'tweets': ((value['tweets'] as Array<any>).map(DropXTweetResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

